import SwitchConnectivity from './SwitchConnectivity';

export default SwitchConnectivity;
